// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-text%2Fsrc%2Fdeltas.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
import { SchemaObject } from '@augloop/types-core';
export class TextTileDelta {
    constructor(obj) {
        SchemaObject.assign(TextTileDelta, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Text_TextTileDelta';
    }
    static getBaseTypes() {
        return ['AugLoop_Core_ItemDelta'];
    }
    /**
     * Checks if passed schema object is of TextTileDelta type or its inheritor and implements {@link ITextTileDelta}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [TextTileDelta.getTypeName()]);
    }
}
TextTileDelta.H_ = { T_: TextTileDelta.getTypeName(), B_: TextTileDelta.getBaseTypes() };
export class FormattedTextTileDelta {
    constructor(obj) {
        SchemaObject.assign(FormattedTextTileDelta, this, obj);
    }
    static getTypeName() {
        return 'AugLoop_Text_FormattedTextTileDelta';
    }
    static getBaseTypes() {
        return ['AugLoop_Text_TextTileDelta', 'AugLoop_Core_ItemDelta'];
    }
    /**
     * Checks if passed schema object is of FormattedTextTileDelta type or its inheritor and implements {@link IFormattedTextTileDelta}
     */
    static typeGuard(schemaObject) {
        return SchemaObject.matchesTypesFor(schemaObject, [FormattedTextTileDelta.getTypeName()]);
    }
}
FormattedTextTileDelta.H_ = { T_: FormattedTextTileDelta.getTypeName(), B_: FormattedTextTileDelta.getBaseTypes() };
//# sourceMappingURL=deltas.g.js.map